import React, { useState } from 'react';
import { Card, CardHeader, CardTitle } from 'components/shadcn/ui/card';
import { HGTable } from 'components/HGTable';
import { useSearch } from 'components/HGTable/hooks/useSearch';
import { useSort } from 'components/HGTable/hooks/useSort';
import { usePage } from 'components/HGTable/hooks';
import { columns } from './constants';
import InviteInstallerModal from './InviteInstallerModal';
import { useUsersList } from '../service';
import { INSTALLER_LIST_LIMIT, INSTALLER_PAGE_SIZE } from './constants';

const Installers = () => {
    const pageSize = INSTALLER_PAGE_SIZE;
    const limit = INSTALLER_LIST_LIMIT;
    const { data: installers, isLoading } = useUsersList('installers', limit);
    const [filterBy, setFilterBy] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [search, setSearch] = useState('');
    const [sortField, setSortField] = useState('');
    const [sortDirection, setSortDirection] = useState('ascending');
    const filteredInstallers = useSearch(
        installers?.items ?? [],
        search,
        filterBy
    );
    const installersToShow = usePage(filteredInstallers, currentPage, pageSize);
    const sortedData = useSort(installersToShow, sortField, sortDirection);
    const [openInviteModal, setOpenInviteModal] = useState(false);

    return (
        <Card>
            <CardHeader>
                <CardTitle className="flex items-center justify-between gap-2 text-primary-foreground">
                    Installers
                    <InviteInstallerModal />
                </CardTitle>
            </CardHeader>
            <HGTable
                columns={columns}
                data={sortedData}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                totalItems={filteredInstallers?.length}
                pageSize={pageSize}
                search={search}
                filterBy={filterBy}
                setFilterBy={setFilterBy}
                setSearch={setSearch}
                sortField={sortField}
                setSortField={setSortField}
                sortDirection={sortDirection}
                setSortDirection={setSortDirection}
                loading={isLoading}
                skeletonRows={20}
                canFilter={true}
                canSearch={true}
                onSearchChange={(e) => {
                    setSearch(e);
                }}
                openInviteModal={openInviteModal}
                setOpenInviteModal={setOpenInviteModal}
            />
        </Card>
    );
};

export default Installers;
